export const popoutGradiant = `<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1307_5079)">
<path d="M13.8752 2.97527H17.4634L10.1191 10.3195L12.0811 12.2815L19.4254 4.93725V8.52542H22.2004V0.200195H13.8752V2.97527Z" fill="url(#paint0_linear_1307_5079)"/>
<path d="M2.77508 2.97559H11.1003V5.75066H2.77508V19.626H16.6505V11.3008H19.4255V19.626C19.4255 20.362 19.1332 21.0679 18.6127 21.5883C18.0923 22.1087 17.3865 22.4011 16.6505 22.4011H2.77508C2.03908 22.4011 1.33323 22.1087 0.812801 21.5883C0.292373 21.0679 0 20.362 0 19.626V5.75066C0 5.01467 0.292373 4.30881 0.812801 3.78839C1.33323 3.26796 2.03908 2.97559 2.77508 2.97559Z" fill="url(#paint1_linear_1307_5079)"/>
</g>
<defs>
<linearGradient id="paint0_linear_1307_5079" x1="10.1191" y1="2.46544" x2="22.2004" y2="12.2815" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF53FF"/>
<stop offset="1" stop-color="#99F1FF"/>
</linearGradient>
<linearGradient id="paint1_linear_1307_5079" x1="9.49801e-08" y1="6.61787" x2="19.4255" y2="22.4012" gradientUnits="userSpaceOnUse">
<stop stop-color="#FF53FF"/>
<stop offset="1" stop-color="#99F1FF"/>
</linearGradient>
<clipPath id="clip0_1307_5079">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>`;
